/* LODYFAIR PRODUCTPAGINA — Horizon. Winkelbouwer, 10 oktober 2026.

   Vervangt wat Impulse theme.js op de productpagina deed, met dezelfde haakjes, zodat de live
   lodyfair-snippets (koopbalk, prod-besparing, walletregel, voorraadmelding, inhoudswaarde,
   staffelkiezer, mysterybox, outfit-stukken, shirt-personalisatie, maatadviseur) ongewijzigd
   meewerken:
     - keuzerondjes input[data-variant-input] in .variant-input-wrap  →  variant zoeken
     - select[name="id"] in het formulier bijwerken, ?variant= in de adresbalk
     - event `variant:change` (detail.variant) — bubbelt naar document, zoals Impulse
     - prijs [data-product-price] / [data-compare-price], eenheidsprijs, SKU, levertijd per variant
     - knop [name="add"] + [data-add-to-cart-text]: Toevoegen / Kies je maat / Uitverkocht
     - galerij: vegen, teller, miniaturen, naar de foto van de gekozen kleur, vergroten
     - toevoegen via /cart/add.js en dan de LodyFair-lade (window.lfCart.open)

   NIEUW: zolang er geen maat gekozen is staat data-lf-kies-maat op de knop; een klik wijst de
   maatkeuze aan in plaats van een willekeurige maat toe te voegen (ontwerpbord 03).

   Laat met rust: een knop met data-lf-drop-blokkade (assets/lodyfair-drop.js beheert die), en een
   formulier met [data-lf-aanvraag-blok] (assets/lodyfair-op-aanvraag.js verstuurt dat zelf). */
(function () {
  'use strict';

  function geld(c) {
    var heel = Math.floor(Math.abs(c) / 100), rest = Math.abs(c) % 100;
    return '€' + String(heel).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (rest < 10 ? '0' + rest : rest);
  }

  function initPdp(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var bak = root.querySelector('[data-variant-json]');
    var varianten = [];
    try { varianten = JSON.parse(bak.textContent); } catch (e) { return; }

    var select = form.querySelector('select[name="id"]');
    var knop = form.querySelector('[name="add"]');
    var knopTekst = knop ? knop.querySelector('[data-add-to-cart-text]') : null;
    var melding = form.querySelector('[data-lf-pdp-melding]');
    var groepen = Array.prototype.slice.call(root.querySelectorAll('.variant-input-wrap'));
    var T = {
      toevoegen: root.getAttribute('data-tekst-toevoegen') || 'Toevoegen aan winkelwagen',
      kies: root.getAttribute('data-tekst-kies') || 'Kies je maat',
      uit: root.getAttribute('data-tekst-uit') || 'Uitverkocht',
      fout: root.getAttribute('data-tekst-fout') || 'Toevoegen lukte niet.'
    };
    var huidige = null;

    function keuzes() {
      return groepen.map(function (fs) {
        var c = fs.querySelector('input[data-variant-input]:checked');
        return c ? c.value : null;
      });
    }

    function vind(k) {
      if (!groepen.length) return varianten[0] || null;
      for (var i = 0; i < k.length; i++) if (k[i] === null) return null;
      for (var v = 0; v < varianten.length; v++) {
        var ok = true;
        for (var j = 0; j < k.length; j++) {
          if (varianten[v].options[j] !== k[j]) { ok = false; break; }
        }
        if (ok) return varianten[v];
      }
      return false; /* combinatie bestaat niet */
    }

    /* G1 (29-10-2026): is er nog geen maat gekozen, dan is er geen variant (v === null). De kleur moet
       dan tóch doorwerken op foto, prijs en ?variant=: neem de eerste (liefst leverbare) variant die
       bij de gekozen opties past. De koopknop blijft om een maat vragen. */
    function representant(k) {
      var eerste = null;
      for (var v = 0; v < varianten.length; v++) {
        var ok = true;
        for (var j = 0; j < k.length; j++) {
          if (k[j] !== null && varianten[v].options[j] !== k[j]) { ok = false; break; }
        }
        if (!ok) continue;
        if (varianten[v].available) return varianten[v];
        if (!eerste) eerste = varianten[v];
      }
      return eerste;
    }

    function markeerBeschikbaar(k) {
      groepen.forEach(function (fs, i) {
        fs.querySelectorAll('input[data-variant-input]').forEach(function (inp) {
          var ok = varianten.some(function (v) {
            if (!v.available || v.options[i] !== inp.value) return false;
            for (var j = 0; j < k.length; j++) {
              if (j !== i && k[j] !== null && v.options[j] !== k[j]) return false;
            }
            return true;
          });
          inp.classList.toggle('disabled', !ok);
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('disabled', !ok);
        });
      });
    }

    function zetLabels(k) {
      groepen.forEach(function (fs, i) {
        var wrap = fs.closest('.variant-wrapper');
        if (!wrap) return;
        var kleur = wrap.querySelector('[data-variant-color-label]');
        if (kleur && k[i] !== null) kleur.textContent = k[i];
        var maat = wrap.querySelector('[data-lf-maat-gekozen]');
        var hint = wrap.querySelector('[data-lf-maat-hint]');
        if (maat) maat.textContent = k[i] !== null ? ': ' + k[i] : '';
        if (hint) hint.hidden = k[i] !== null;
        if (k[i] !== null) wrap.classList.remove('is-kies');
      });
    }

    function zetKnop(v) {
      if (!knop || knop.hasAttribute('data-lf-drop-blokkade')) return;
      var tekst;
      if (v === null) {
        /* Ontwerpbord 03: de knop zegt altijd "Toevoegen aan winkelwagen"; zonder maat wijst een
           klik de maatkeuze aan. */
        knop.setAttribute('data-lf-kies-maat', '');
        knop.disabled = false;
        tekst = T.toevoegen;
      } else {
        knop.removeAttribute('data-lf-kies-maat');
        if (v && v.available) { knop.disabled = false; tekst = T.toevoegen; }
        else { knop.disabled = true; tekst = T.uit; }
      }
      if (knopTekst) knopTekst.textContent = tekst; else knop.textContent = tekst;
    }

    function zetPrijs(v) {
      var nu = root.querySelector('[data-product-price]');
      var was = root.querySelector('[data-compare-price]');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (nu) { nu.textContent = geld(v.price); nu.classList.toggle('is-sale', !!sale); }
      if (was) { was.textContent = sale ? geld(v.compare_at_price) : ''; was.hidden = !sale; }
      var eWrap = root.querySelector('[data-unit-price-wrapper]');
      if (eWrap) {
        if (v.unit_price_measurement) {
          var m = v.unit_price_measurement;
          eWrap.querySelector('[data-unit-price]').textContent = geld(v.unit_price);
          eWrap.querySelector('[data-unit-base]').textContent = (m.reference_value !== 1 ? m.reference_value : '') + m.reference_unit;
          eWrap.hidden = false;
        } else { eWrap.hidden = true; }
      }
      var sku = root.querySelector('[data-sku]');
      if (sku) sku.textContent = v.sku || '';
      var lt = root.querySelector('[data-lf-levertijd]');
      if (lt) {
        var map = {};
        try { map = JSON.parse(lt.getAttribute('data-lf-levertijd-varianten') || '{}'); } catch (e) {}
        var d = map[String(v.id)] || lt.getAttribute('data-standaard');
        var el = lt.querySelector('[data-lf-levertijd-dagen]');
        if (el && d) el.textContent = d;
        lt.classList.toggle('is-snel', d === '1–2');
      }
    }

    function update(bron) {
      var k = keuzes();
      var v = vind(k);
      markeerBeschikbaar(k);
      zetLabels(k);
      zetKnop(v);
      var rep = v || representant(k);
      if (rep) {
        if (select) select.value = String(rep.id);
        zetPrijs(rep);
        if (bron === 'keuze') {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', rep.id);
            window.history.replaceState({}, '', u.toString());
          } catch (e) {}
          if (rep.featured_media && media) media.naar(rep.featured_media.id);
        }
      }
      if (v) {
        huidige = v;
        root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
      } else {
        huidige = null;
      }
    }

    function toonMelding(t) {
      if (!melding) return;
      melding.textContent = t || '';
      melding.hidden = !t;
    }

    function wijsMaatAan() {
      var k = keuzes();
      for (var i = 0; i < groepen.length; i++) {
        if (k[i] === null) {
          var wrap = groepen[i].closest('.variant-wrapper') || groepen[i];
          wrap.classList.remove('is-kies');
          void wrap.offsetWidth; /* animatie opnieuw starten */
          wrap.classList.add('is-kies');
          var r = wrap.getBoundingClientRect();
          if (r.top < 70 || r.bottom > window.innerHeight) {
            wrap.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          }
          var eerste = groepen[i].querySelector('input[data-variant-input]:not(.disabled)') || groepen[i].querySelector('input[data-variant-input]');
          if (eerste) { try { eerste.focus({ preventScroll: true }); } catch (e) {} }
          return;
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-variant-input]')) { toonMelding(''); update('keuze'); }
    });
    /* De rondjes staan in het formulier via form="…", maar ook buiten root kan iemand ze aanzetten. */
    if (select) {
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        for (var i = 0; i < varianten.length; i++) {
          if (varianten[i].id === id && (!huidige || huidige.id !== id)) {
            huidige = varianten[i];
            zetPrijs(huidige);
            zetKnop(huidige);
            root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: huidige } }));
          }
        }
      });
    }

    /* Versturen. Op document (bubbelfase), zodat de vangnetten van outfit-stukken (capture) en
       op-aanvraag eerst aan de beurt zijn. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form || e.defaultPrevented) return;
      if (form.querySelector('[data-lf-aanvraag-blok]')) return;
      e.preventDefault();
      if (!knop || knop.disabled) return;
      if (knop.hasAttribute('data-lf-kies-maat')) { wijsMaatAan(); return; }
      if (knop.classList.contains('is-bezig')) return;

      knop.classList.add('is-bezig');
      knop.setAttribute('aria-busy', 'true');
      toonMelding('');
      var extra = lookItems();
      var opties = {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      };
      if (extra.length) {
        /* "Maak de look af": hoofdstuk + aangevinkte stukken in één verzoek. */
        var fd = new FormData(form), hoofd = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }, props = {};
        fd.forEach(function (w, k) {
          var m = /^properties\[(.+)\]$/.exec(k);
          if (m && typeof w === 'string') props[m[1]] = w;
          if (k === 'selling_plan' && w) hoofd.selling_plan = Number(w);
        });
        if (Object.keys(props).length) hoofd.properties = props;
        opties.body = JSON.stringify({ items: [hoofd].concat(extra) });
        opties.headers['Content-Type'] = 'application/json';
      }
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', opties)
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            if (!r.ok) { var f = new Error('mislukt'); f.uitleg = d && (d.description || d.message); throw f; }
            return d;
          });
        })
        .then(function () {
          if (window.lfCart && typeof window.lfCart.open === 'function') window.lfCart.open();
          else document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function (f) { toonMelding((f && f.uitleg) || T.fout); })
        .then(function () { knop.classList.remove('is-bezig'); knop.removeAttribute('aria-busy'); });
    });

    /* ---------- maak de look af ---------- */
    var look = root.querySelector('[data-lf-look]');
    function lookItems() {
      if (!look) return [];
      var uit = [];
      look.querySelectorAll('[data-lf-look-rij]').forEach(function (rij) {
        var vink = rij.querySelector('[data-lf-look-vink]');
        var keuze = rij.querySelector('[data-lf-look-variant]');
        if (vink && vink.checked && keuze && keuze.value) uit.push({ id: Number(keuze.value), quantity: 1 });
      });
      return uit;
    }
    function lookTotaal() {
      if (!look) return;
      var tot = 0, n = 0;
      look.querySelectorAll('[data-lf-look-rij]').forEach(function (rij) {
        var vink = rij.querySelector('[data-lf-look-vink]');
        var keuze = rij.querySelector('[data-lf-look-variant]');
        rij.classList.toggle('is-aan', !!(vink && vink.checked));
        if (!vink || !vink.checked || !keuze || !keuze.value) return;
        var opt = keuze.options ? keuze.options[keuze.selectedIndex] : null;
        tot += parseInt((opt && opt.getAttribute('data-prijs')) || rij.getAttribute('data-prijs') || '0', 10);
        n++;
      });
      var el = look.querySelector('[data-lf-look-totaal]');
      if (!el) return;
      if (n && huidige) {
        el.querySelector('[data-lf-look-bedrag]').textContent = geld(tot + huidige.price);
        el.hidden = false;
      } else { el.hidden = true; }
    }
    if (look) {
      look.addEventListener('change', function (e) {
        var rij = e.target.closest('[data-lf-look-rij]');
        if (rij && e.target.matches('[data-lf-look-variant]') && e.target.value) {
          var vink = rij.querySelector('[data-lf-look-vink]');
          if (vink) vink.checked = true;
        }
        lookTotaal();
      });
      root.addEventListener('variant:change', lookTotaal);
    }

    /* ---------- uitklapblok Maattabel opent dezelfde maattabel als de link bij de maat ---------- */
    var maatOpener = root.querySelector('[data-lf-maat-open]');
    var maatAcc = root.querySelector('[data-lf-acc-maattabel]');
    if (maatAcc && maatOpener) {
      maatAcc.hidden = false;
      var proxy = maatAcc.querySelector('[data-lf-maattabel-proxy]');
      if (proxy) proxy.addEventListener('click', function () { maatOpener.click(); });
    }

    /* ---------- galerij ---------- */
    var media = initMedia(root.querySelector('[data-lf-media]'));

    update('laden');
  }

  function initMedia(el) {
    if (!el) return null;
    var rij = el.querySelector('[data-lf-media-rij]');
    var dias = Array.prototype.slice.call(el.querySelectorAll('[data-lf-dia]'));
    var duimen = Array.prototype.slice.call(el.querySelectorAll('[data-lf-duim]'));
    var nuEl = el.querySelector('[data-lf-media-nu]');
    var groot = el.querySelector('[data-lf-groot]');
    var index = 0;

    function zet(i) {
      index = i;
      if (nuEl) nuEl.textContent = i + 1;
      duimen.forEach(function (d, j) { d.classList.toggle('is-actief', j === i); });
    }
    function ga(i, zacht) {
      if (!rij || !dias[i]) return;
      rij.scrollTo({ left: dias[i].offsetLeft - rij.offsetLeft, behavior: zacht ? 'smooth' : 'auto' });
      zet(i);
    }
    var t = null;
    if (rij) {
      rij.addEventListener('scroll', function () {
        if (t) cancelAnimationFrame(t);
        t = requestAnimationFrame(function () {
          var w = rij.clientWidth || 1;
          var i = Math.round(rij.scrollLeft / w);
          if (i !== index && dias[i]) zet(i);
        });
      }, { passive: true });
      rij.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' && index < dias.length - 1) { e.preventDefault(); ga(index + 1, true); }
        if (e.key === 'ArrowLeft' && index > 0) { e.preventDefault(); ga(index - 1, true); }
      });
    }
    duimen.forEach(function (d) {
      d.addEventListener('click', function () { ga(parseInt(d.getAttribute('data-lf-duim'), 10) || 0, true); });
    });
    if (groot && typeof groot.showModal === 'function') {
      var img = groot.querySelector('[data-lf-groot-img]');
      el.addEventListener('click', function (e) {
        var z = e.target.closest('[data-lf-zoom]');
        if (!z) return;
        img.src = z.getAttribute('data-lf-zoom');
        groot.showModal();
      });
      groot.addEventListener('click', function (e) {
        if (e.target === groot || e.target.closest('[data-lf-groot-sluit]')) groot.close();
      });
    } else {
      el.querySelectorAll('[data-lf-zoom]').forEach(function (z) { z.setAttribute('tabindex', '-1'); });
    }

    var startEl = el.querySelector('[data-lf-media-start]');
    var start = startEl ? parseInt(startEl.textContent, 10) : 0;

    var api = {
      naar: function (id) {
        for (var i = 0; i < dias.length; i++) {
          if (dias[i].getAttribute('data-media-id') === String(id)) { ga(i, true); return; }
        }
      }
    };
    if (start) {
      for (var i = 0; i < dias.length; i++) {
        if (dias[i].getAttribute('data-media-id') === String(start)) { if (i) ga(i, false); break; }
      }
    }
    return api;
  }

  document.querySelectorAll('[data-lf-pdp]').forEach(initPdp);
})();
